const producttariff = {
  getlist: 'producttariff/getlist',
  add: 'producttariff/add',
  update: 'producttariff/update',
  remove: 'producttariff/remove',
  get: 'producttariff/get',
  getall: 'producttariff/getall',
  clearcache: 'producttariff/clear-cache',
}
export default producttariff
